/**
     * @desc 查询NFT交易历史信息列表
用于NFT拍卖页/购买页
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/getItemTradingHistoryHistory', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/getItemTradingHistoryHistory', params);
}
